import { Injectable, computed, signal } from '@angular/core';

export type CografaTheme = 'light' | 'brand' | 'dark';

export const THEME_OPTIONS: readonly { id: CografaTheme; label: string; icon: string }[] = [
  { id: 'light', label: 'Claro', icon: 'light_mode' },
  { id: 'brand', label: 'Menú verde', icon: 'view_sidebar' },
  { id: 'dark', label: 'Oscuro', icon: 'dark_mode' },
];

const ORDER: readonly CografaTheme[] = THEME_OPTIONS.map((opt) => opt.id);
const CLASS: Record<CografaTheme, string> = {
  light: 'cografa-theme-light',
  brand: 'cografa-theme-brand',
  dark: 'cografa-theme-dark',
};
const KEY = 'cografa:theme';

@Injectable({ providedIn: 'root' })
export class ThemeService {
  readonly options = THEME_OPTIONS;
  readonly theme = signal<CografaTheme>(readTheme());
  readonly current = computed(() => THEME_OPTIONS.find((opt) => opt.id === this.theme()) ?? THEME_OPTIONS[0]);

  constructor() {
    this.apply(this.theme());
  }

  setTheme(theme: CografaTheme): void {
    this.theme.set(theme);
    this.apply(theme);
    localStorage.setItem(KEY, theme);
  }

  private apply(theme: CografaTheme): void {
    const root = document.documentElement;
    for (const cls of Object.values(CLASS)) root.classList.remove(cls);
    root.classList.add(CLASS[theme]);
    root.style.colorScheme = theme === 'dark' ? 'dark' : 'light';
    const meta = document.querySelector('meta[name="theme-color"]');
    if (meta) meta.setAttribute('content', theme === 'dark' ? '#141210' : '#1f4d3a');
  }
}

function readTheme(): CografaTheme {
  const stored = localStorage.getItem(KEY);
  return ORDER.includes(stored as CografaTheme) ? (stored as CografaTheme) : 'brand';
}
